/**
 * Created by Alex Poh. on 19/07/20.
 * Copyright © 2020 Curriculum Ltd. All rights reserved.
 */

import { Directive, ElementRef, Input, OnChanges, OnDestroy, OnInit, SimpleChanges } from '@angular/core';
import { Subject } from 'rxjs';
import { MathServiceImpl } from './math.service';
import { take, takeUntil } from 'rxjs/operators';
import { MathContent } from './math-content';

@Directive({ selector: '[currMath]' })
export class MathDirective implements OnInit, OnChanges, OnDestroy {
  private unsubscribe$ = new Subject<void>();
  @Input() currMath!: MathContent | string;
  private readonly _el: HTMLElement;

  constructor(private service: MathServiceImpl, el: ElementRef) {
    this._el = el.nativeElement as HTMLElement;
  }

  ngOnInit(): void {
    this.service
      .ready()
      .pipe(take(1), takeUntil(this.unsubscribe$))
      .subscribe(res => {
        this.service.render(this._el, this.currMath);
      });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if ('currMath' in changes) {
      this.service.render(this._el, this.currMath);
    }
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }
}
